// Centralne ustawienia logowania: przekaż `console.log` do `console.debug` w trybie DEV
// oraz wycisz `console.log` w produkcji, żeby zmniejszyć hałas w konsoli.
const isDev = ((import.meta as any)?.env?.DEV) === true || false

if (typeof window !== 'undefined') {
  try {
    if (isDev) {
      // mapuj logi na debug — domyślnie przeglądarki mogą je ukrywać
      console.log = (...args: any[]) => { console.debug(...args) }
    } else {
      // w produkcji wyciszamy zwykłe logi
      console.log = () => {}
    }
  } catch (e) {
    // Nie przerywamy działania aplikacji jeśli nadpisanie nie powiedzie się
  }
}
